import type { SxProps, Theme } from '@mui/material/styles';

export const brandMarkStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 0,
    flexShrink: 0,
  },
  img: {
    display: 'block',
    height: '100%',
    width: 'auto',
  },
};
